import axios from "axios";
import store from "@/store";

export default {
  state: {
    trainerProfile: [],
    userProfile: [],
    userProfileUpdate: [],
    trainerProfileUpdate: [],
    sessionReviewBatch: [],
    userReviewSessionPost: [],
    userReviewLike: [],
    trainerProfileReviews: [],
    livestreamSessionBatch: [],
    trainerDetail: [],
    trainerReviews: [],
    userFollowTrainer: [],
    userReviewTrainerPost: [],
    trainerList: [],
    trainerStoreAdd: [],
    trainerStoreList: [],
    userStoreList: [],
    trainerStoreView: [],
    trainerStoreUpdate: [],
    trainerStoreDelete: [],
    trainerViewStores: [],
    trainerAddStores: [],
    trainerPostCreate: [],
    trainerPostList: {},
    trainerPostView: [],
    trainerPostDelete: [],
    postComment: [],
    userTrainerPosts: [],
    userFollowedTrainerPosts: [],
    commentDelete: [],
    postCommentLike: [],
    trainerActiveSessions: [],
    userMessageNew: [],
    userSessionTxnHistory: [],
    userCourseTxnHistory: [],
    userCreditPurchaseHistory: [],
    trainerProfileBannerUpdate: [],
    userProfileUpdateDp: [],
    userProfileRemoveDp: [],
    trainerProfileRemoveDp: [],
    trainerProfileUpdateDp: [],
    categoriesList: [],
    trainerProfileBannerRemove: [],
    topTrainerList: [],
    categoryTrainerList: [],
    languageTrainerList: [],
    userCardList: [],
    countries: [],
    states: [],
    cities: [],
    roles: [],
    cardDetails: {},
    userCompletePaymentBookClass: [],
    trainerProfileDetails: [],
    trainerTipTransactionList: [],
    userOrders: [],
    userTipTransactionList: [],
    trainerOrderList: [],
    userCompleteTipPayment: [],
    userBookFreeClass: [],
    userCancelOrder: [],
    userProfileDetails: [],
    isChatBotVisible: true,
    tutorialNotified: false
  },

  getters: {
    userProfileDetails(state) {
      return state.userProfileDetails
    },
    userCompleteTipPayment(state) {
      return state.userCompleteTipPayment
    },
    userBookFreeClass(state) {
      return state.userBookFreeClass
    },
    trainerProfileDetails(state) {
      return state.trainerProfileDetails;
    },
    userCompletePaymentBookClass(state) {
      return state.userCompletePaymentBookClass;
    },
    languageTrainerList(state) {
      return state.languageTrainerList;
    },
    categoryTrainerList(state) {
      return state.categoryTrainerList;
    },
    topTrainerList(state) {
      return state.topTrainerList;
    },
    trainerProfileBannerRemove(state) {
      return state.trainerProfileBannerRemove;
    },
    categoriesList(state) {
      return state.categoriesList;
    },
    trainerProfileUpdateDp(state) {
      return state.trainerProfileUpdateDp;
    },
    trainerProfileRemoveDp(state) {
      return state.trainerProfileRemoveDp;
    },
    userProfileUpdateDp(state) {
      return state.userProfileUpdateDp;
    },
    userProfileRemoveDp(state) {
      return state.userProfileUpdateDp;
    },
    userMessageNew(state) {
      return state.userMessageNew;
    },
    trainerActiveSessions(state) {
      return state.trainerActiveSessions;
    },
    postCommentLike(state) {
      return state.postCommentLike;
    },
    commentDelete(state) {
      return state.commentDelete;
    },
    userFollowedTrainerPosts(state) {
      return state.userFollowedTrainerPosts;
    },
    userTrainerPosts(state) {
      return state.userTrainerPosts;
    },
    postComment(state) {
      return state.postComment;
    },
    trainerPostDelete(state) {
      return state.trainerPostDelete;
    },
    trainerPostView(state) {
      return state.trainerPostView;
    },
    trainerPostList(state) {
      return state.trainerPostList;
    },
    trainerPostCreate(state) {
      return state.trainerPostCreate;
    },
    trainerAddStores(state) {
      return state.trainerAddStores;
    },
    trainerViewStores(state) {
      return state.trainerViewStores;
    },
    trainerStoreDelete(state) {
      return state.trainerStoreDelete;
    },
    trainerStoreUpdate(state) {
      return state.trainerStoreUpdate;
    },
    trainerStoreView(state) {
      return state.trainerStoreView;
    },
    userStoreList(state) {
      return state.userStoreList;
    },
    trainerStoreAdd(state) {
      return state.trainerStoreAdd;
    },
    trainerStoreList(state) {
      return state.trainerStoreList;
    },
    trainerList(state) {
      return state.trainerList;
    },
    userReviewTrainerPost(state) {
      return state.userReviewTrainerPost;
    },
    userFollowTrainer(state) {
      return state.userFollowTrainer;
    },
    trainerDetail(state) {
      return state.trainerDetail;
    },
    trainerReviews(state) {
      return state.trainerReviews;
    },
    livestreamSessionBatch(state) {
      return state.livestreamSessionBatch;
    },
    trainerProfile(state) {
      return state.trainerProfile;
    },
    userProfile(state) {
      return state.userProfile;
    },
    userProfileUpdate(state) {
      return state.userProfileUpdate;
    },
    trainerProfileUpdate(state) {
      return state.trainerProfileUpdate;
    },
    trainerProfileBannerUpdate(state) {
      return state.trainerProfileBannerUpdate;
    },
    sessionReviewBatch(state) {
      return state.sessionReviewBatch;
    },
    userReviewSessionPost(state) {
      return state.userReviewSessionPost;
    },
    userReviewLike(state) {
      return state.userReviewLike;
    },
    trainerProfileReviews(state) {
      return state.trainerProfileReviews;
    },
    userSessionTxnHistory(state) {
      return state.userSessionTxnHistory;
    },
    userCourseTxnHistory(state) {
      return state.userCourseTxnHistory;
    },
    userCreditPurchaseHistory(state) {
      return state.userCreditPurchaseHistory;
    },
    userCardList(state) {
      return state.userCardList;
    },
    countryList(state) {
      return state.countries;
    },
    stateList(state) {
      return state.states;
    },
    cityList(state) {
      return state.cities;
    },
    cardData(state) {
      return state.cardDetails;
    },
    getRoles(state) {
      return state.roles;
    },
    trainerTipTransactionList(state) {
      return state.trainerTipTransactionList;
    },
    userOrderList(state) {
      return state.userOrders;
    },
    userTipTransactionList(state) {
      return state.userTipTransactionList;
    },
    trainerOrderList(state) {
      return state.trainerOrderList;
    },
    userCancelOrder(state) {
      return state.userCancelOrder
    },
    isChatBotVisible: state => state.isChatBotVisible,
    tutorialNotified: state => state.tutorialNotified
  },

  actions: {
    async getTrainerProfile({ commit }) {
      const res = await axios.get("trainer/profile");

      const data = res && res.data && res.data.data;
      commit("setTrainerProfile", data);
    },

    async getUserProfile({ commit }, { query }) {
      try {
        const res = await axios.get("user/profile", { params: query || {} });
        const data = res && res.data && res.data.data;
        commit("setUserProfile", data);
      } catch (err) {
        console.log(err)
      }
    },

    async userProfileUpdate({ commit }, data) {
      try {
        const res = await axios.post("user/profile/update", data);
        store.commit("setIsSuccess", res && res.data && res.data.message);
        const newData = res && res.data && res.data.data;
        commit("setUserProfileUpdate", newData);
      } catch(err) {
        console.log(err)
        commit('setError', {title: "Alert", text: 'Something went wrong, profile updation failed.'})
        throw err
      } 
    },

    async userProfileUpdateBanner({ commit }, data) {
      try {
        const res = await axios.post("user/profile/banner/update", data);
        store.commit("setIsSuccess", res && res.data && res.data.message);
        const newData = res && res.data && res.data.data;
        commit("setUserProfileUpdateDp", newData);
      } catch(err) {
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err
      }
    },
    async userProfileUpdateDp({ commit }, data) {
      const res = await axios.post("user/profile/updatedp", data);

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const newData = res && res.data && res.data.data;
      commit("setUserProfileUpdateDp", newData);
    },
    async trainerProfileUpdateDp({ commit }, data) {
      const res = await axios.post("trainer/profile/updatedp", data);

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const newData = res && res.data && res.data.data;
      commit("setTrainerProfileUpdateDp", newData);
    },

    async userProfileRemoveDp({ commit }, data) {
      const res = await axios.post("user/profile/removedp", data);

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const newData = res && res.data && res.data.data;
      commit("setUserProfileRemoveDp", newData);
    },

    async trainerProfileBannerRemove({ commit }, data) {
      try {
        const res = await axios.post("trainer/profile/banner/remove", data);
        store.commit("setIsSuccess", res && res.data && res.data.message);
        // const newData = res && res.data && res.data.data;
        // commit("setTrainerProfileBannerRemove", newData);
      } catch(err) {
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err
      }
    },
    async userProfileBannerRemove({ commit }, data) {
      try {
        const res = await axios.post("user/profile/banner/remove", data);
        store.commit("setIsSuccess", res && res.data && res.data.message);
      } catch(err) {
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err
      }
    },

    async trainerProfileRemoveDp({ commit }, data) {
      try {
        const res = await axios.post("trainer/profile/removedp", data);
        store.commit("setIsSuccess", res && res.data && res.data.message);
        const newData = res && res.data && res.data.data;
        commit("setTrainerProfileRemoveDp", newData);
      } catch (err) {
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },

    async trainerProfileUpdate({ commit }, data) {
      const res = await axios.post("trainer/profile/update", data);

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const newData = res && res.data && res.data.data;
      commit("setTrainerProfileUpdate", newData);
    },

    async trainerProfileBannerUpdate({ commit }, data) {
      const res = await axios.post("trainer/profile/banner/update", data);

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const newData = res && res.data && res.data.data;
      commit("setTrainerProfileBannerUpdate", newData);
    },

    async trainerStoreAdd({ commit }, data) {
      const res = await axios.post("trainer/store/add", data);

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const newData = res && res.data && res.data.data;
      commit("setTrainerStoreAdd", newData);
    },

    async trainerStoreUpdate({ commit }, data) {
      let id = ""; // check
      for (var pair of data.entries()) {
        if (pair[0] == "id") {
          id = pair[1];
        }
      }
      const res = await axios.post(`trainer/store/update/${id}`, data);

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const newData = res && res.data && res.data.data;
      commit("setTrainerStoreUpdate", newData);
    },

    async getTrainerStoreList({ commit }) {
      commit("loadingStatus", true);
      await axios
        .get(`trainer/store/list`)
        .then((res) => {
          commit("setTrainerStoreList", (res && res.data) || {});
          commit("loadingStatus", false);
        })
        .catch((e) => {
          commit("setTrainerStoreList", (e.response && e.response.data) || {});
          commit("loadingStatus", false);
        });
    },

    async getTrainerStoreListMore({ commit }, id) {
      const res = await axios.get(`trainer/store/list${id}`);

      const data = res && res.data && res.data.data;
      commit("setTrainerStoreListMore", data);
    },

    async getUserStoreList({ commit }, id) {
      const res = await axios.get(`user/trainer/${id}/stores`);

      const data = res && res.data && res.data.data && res.data.data.data;
      commit("setUserStoreList", data);
    },

    async getTrainerPostView({ commit }, id) {
      const res = await axios.get(`post/view/${id}`); // check

      const data = res && res.data && res.data.data;
      commit("setTrainerPostView", data);
    },

    async trainerStoreDelete({ commit }, id) {
      const res = await axios.post(`trainer/store/delete/${id}`);

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const data = res && res.data && res.data.data.data;
      commit("setTrainerStoreDelete", data);
    },

    async trainerAddStores({ commit }, data) {
      const res = await axios.post(`trainer/add/stores`, data);

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const newData = res && res.data && res.data.data;
      commit("setTrainerAddStores", newData);
    },

    async getTrainerViewStores({ commit }, id) {
      const res = await axios.get(`trainer/view/stores/${id}`);

      const data = res && res.data && res.data.data;
      commit("setTrainerViewStores", data);
    },

    async getTrainerStoreView({ commit }, id) {
      const res = await axios.get(`trainer/store/view/${id}`);

      const data = res && res.data && res.data.data;
      commit("setTrainerStoreView", data);
    },

    async getTrainerProfileReviews({ commit }) {
      const res = await axios.get("trainer/profile/reviews");

      const data = res && res.data && res.data.data;
      commit("setTrainerProfileReviews", data);
    },

    async getSessionReviewBatch({ commit }, id) {
      const res = await axios.get(`session/review/batch/${id}`);

      const data = res && res.data && res.data.data;
      commit("setSessionReviewBatch", data);
    },

    async getLivestreamSessionBatch({ commit }, id) {
      const res = await axios.get(`livestream/session/batch/${id}`);

      const data = res && res.data && res.data.data;
      commit("setLivestreamSessionBatch", data);
    },

    async getTrainerDetail({ commit }, id) {
      const res = await axios.get(`user/trainer/${id}/detail`);

      const data = res && res.data && res.data.data;
      commit("setTrainerDetail", data);
    },

    async getTrainerList({ commit }, { query, payload = {} }) {
      commit("loadingStatus", true);

      await axios
        .post(`search/trainer`, payload, { params: query || {} })
        .then((res) => {
          commit("setTrainerList", (res && res.data) || {});
          commit("loadingStatus", false);
        })
        .catch((e) => {
          commit("setTrainerList", (e.response && e.response.data) || {});
          commit("loadingStatus", false);
        });
    },

    async getTrainerReviews({ commit }, id) {
      commit("loadingStatus", true);
      await axios
        .get(`user/trainer/${id}/reviews`)
        .then((res) => {
          commit("setTrainerReviews", (res && res.data) || {});
          commit("loadingStatus", false);
        })
        .catch((e) => {
          commit("setTrainerReviews", (e.response && e.response.data) || {});
          commit("loadingStatus", false);
        });
    },

    async getTrainerActiveSessions({ commit }, { payload, query }) {
      commit("loadingStatus", true);

      await axios
        .post(`user/trainer/activesessions`, payload, {
          params: query || {},
        })
        .then((res) => {
          commit("setTrainerActiveSessions", (res && res.data) || {});
          commit("loadingStatus", false);
        })
        .catch((e) => {
          commit(
            "setTrainerActiveSessions",
            (e.response && e.response.data) || {}
          );
          commit("loadingStatus", false);
        });
    },

    async getTrainerPostList({ commit }, query) {
      store.commit("setIsLoading", true);
      try {
        const res = await axios.get(`trainer/post/list`, { params: query });
        const newData = res && res.data && res.data.data;
        commit("setTrainerPostList", newData || {});
        store.commit("setIsLoading", false);
      } catch(err) {
        store.commit("setIsLoading", false);
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },
    async getAdminTrainerPostList({ commit }, payload) {
      store.commit("setIsLoading", true);
      try {
        const res = await axios.get(`admin/trainer/${payload.roleId}/posts`, { params: payload.query });
        const newData = res && res.data && res.data.data;
        commit("setTrainerPostList", newData || {});
        store.commit("setIsLoading", false);
      } catch(err) {
        store.commit("setIsLoading", false);
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },

    async userFollowTrainer({ commit }, data) {
      const res = await axios.post(`user/follow/trainer`, data);

      const newData = res && res.data && res.data.data;
      commit("setUserFollowTrainer", newData);
    },

    async userReviewSessionPost({ commit }, data) {
      const res = await axios.post(`user/review/session/post`, data);

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const newData = res && res.data && res.data.data;
      newData ? localStorage.removeItem("sessionReview") : ''
      commit("setUserReviewSessionPost", newData);
    },

    async userReviewTrainerPost({ commit }, data) {
      const res = await axios.post(`user/review/trainer/post`, data);

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const newData = res && res.data && res.data.data;
      commit("setUserReviewTrainerPost", newData);
    },

    async userReviewLike({ commit }, data) {
      const res = await axios.post(`user/review/like`, data);

      const newData = res && res.data && res.data.data;
      commit("setUserReviewLike", newData);
    },

    async trainerPostCreate({ commit }, data) {
      try {
        const res = await axios.post(`trainer/post/create`, data);
        store.commit("setIsSuccess", res && res.data && res.data.message);
        const newData = res && res.data && res.data.data;
        commit("setTrainerPostCreate", newData);
      } catch(err) {
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },

    async trainerPostDelete({ commit }, id) {
      try {
        const res = await axios.post(`trainer/post/delete/${id}`);
        store.commit("setIsSuccess", res && res.data && res.data.message);
        const data = res && res.data && res.data.data;
        commit("setTrainerPostDelete", data);
      } catch(err) {
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },

    async commentDelete({ commit }, id) {
      const res = await axios.post(`comment/${id}/delete`);

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const data = res && res.data && res.data.data;
      commit("setCommentDelete", data);
    },

    async postComment({ commit }, data) {
      try {
        const res = await axios.post(`post/comment`, data);
        store.commit("setIsSuccess", res && res.data && res.data.message);
        const newData = res && res.data && res.data.data;
        commit("setPostComment", newData);
      } catch(err) {
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },

    async getUserFollowedTrainerPosts({ commit }, { query }) {
      commit("loadingStatus", true);

      await axios
        .get(`user/followedtrainers/posts`, { params: query || {} })
        .then((res) => {
          commit("setUserFollowedTrainerPosts", (res && res.data) || {});
          commit("loadingStatus", false);
        })
        .catch((e) => {
          commit(
            "setUserFollowedTrainerPosts",
            (e.response && e.response.data) || {}
          );
          commit("loadingStatus", false);
        });
    },

    async getUserTrainerPosts({ commit }, id) {
      const res = await axios.get(`user/trainer/${id}/posts`);

      const data = res && res.data && res.data.data && res.data.data.data;
      commit("setUserTrainerPosts", data);
    },

    async postCommentLike({ commit }, data) {
      try {
        const res = await axios.post(`postcomment/like`, data);
        const newData = res && res.data && res.data.data;
        commit("setPostCommentLike", newData);
      } catch(err) {
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },

    async userMessageNew({ commit }, data) {
      const res = await axios.post(`/user/message/new`, data);

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const newData = res && res.data && res.data.data;
      commit("setUserMessageNew", newData);
    },

    async getUserSessionTxnHistory({ commit }, query) {
      const res = await axios.get("user/transaction/history/session", {
        params: query,
      });

      const newData = res && res.data && res.data.data;
      commit("setUserSessionTxnHistory", newData);
    },

    async getUserCourseTxnHistory({ commit }, query) {
      const res = await axios.get("user/transaction/history/course", {
        params: query,
      });

      const newData = res && res.data && res.data.data;
      commit("setUserCourseTxnHistory", newData);
    },

    async getUserCreditPurchaseHistory({ commit }, query) {
      const res = await axios.get("user/transaction/history/credits", {
        params: query,
      });

      const newData = res && res.data && res.data.data;
      commit("setUserCreditPurchaseHistory", newData);
    },

    async getCategoriesList({ commit }) {
      const res = await axios.get("categories");

      const data = res && res.data && res.data.data;
      commit("setCategoriesList", data);
    },

    async postTopTrainerList({ commit }, payload) {
      await axios
        .post("search/trainer", payload)
        .then((res) => {
          commit("setTopTrainerList", (res && res.data && res.data.data) || {});
        })
        .catch((e) => {
          commit("setTopTrainerList", (e.response && e.response.data) || {});
        });
    },

    async postCategoryTrainerList({ commit }, payload) {
      await axios
        .post("search/trainer", payload)
        .then((res) => {
          commit(
            "setCategoryTrainerList",
            (res && res.data && res.data.data) || {}
          );
        })
        .catch((e) => {
          commit(
            "setCategoryTrainerList",
            (e.response && e.response.data) || {}
          );
        });
    },

    async postLanguageTrainerList({ commit }, payload) {
      await axios
        .post("search/trainer", payload)
        .then((res) => {
          commit(
            "setLanguageTrainerList",
            (res && res.data && res.data.data) || {}
          );
        })
        .catch((e) => {
          commit(
            "setLanguageTrainerList",
            (e.response && e.response.data) || {}
          );
        });
    },

    async deleteTrainerReview({ commit }, id) {
      await axios.post(`user/review/trainer/delete/${id}`);
    },

    async updateTrainerPost({ commit }, data) {
      await axios.post(`user/review/trainer/update/${data.id}`, data);
    },

    async deleteSessionReview({ commit }, id) {
      await axios.post(`user/review/session/delete/${id}`);
    },

    async userReviewSessionUpdate({ commit }, data) {
      await axios.post(`user/review/session/update/${data.id}`, data);
    },

    async addUserCard({ commit }, data) {
      try {
        const res = await axios.post(`user/add-card`, data);
        store.commit(
          "setIsSuccess",
          (res && res.data && res.data.message) || {}
        );
      } catch (e) {
        const error = {
          title: "Error occured",
          text:
            e.response &&
            e.response.data &&
            e.response.data.data &&
            e.response.data.data.message,
        };
        store.commit("setError", error);
      }
    },

    async getUserCardList({ commit }) {
      try {
        const res = await axios.get(`user/card-list`);
        const data = res && res.data && res.data.data;
        commit("setUserCardList", data);
      } catch(err) {
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },

    async switchToTrainer({ commit }) {
      try {
        await axios.get(`user/switch-to-trainer`);
        let user = JSON.parse(localStorage.getItem("user"));
        user.user_type = 2;
        user.isRoleSelected = true;
        localStorage.setItem("user", JSON.stringify(user));
      } catch (err) {
        store.commit("setIsLoading", false);
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },

    async getUserRoles({ commit }) {
      const res = await axios.get(`user/get-roles`);
      commit("setUserRoles", res.data.data);
    },

    async getTrainerRoles({ commit }) {
      await axios.get(`trainer/get-roles`);
    },

    async switchToUser({ commit }) {
      await axios.get(`trainer/switch-to-user`);
    },

    async updateUserEmailId({ commit }, payload) {
      try {
        const res = await axios.post(`user/update-email`, payload);
        store.commit("setIsSuccess", res.data && res.data.message);
      } catch (e) {
        const error = {
          title: "Error occured",
          text:
            e.response &&
            e.response.data &&
            e.response.data.data &&
            e.response.data.data.message,
        };
        store.commit("setError", error);
      }
    },

    async deleteUserCard({ commit }, payload) {
      try {
        const res = await axios.post(`user/update-card-status/${payload}`);
        store.commit(
          "setIsSuccess",
          (res && res.data && res.data.message) || {}
        );
      } catch (e) {
        const error = {
          title: "Error occured",
          text:
            e.response &&
            e.response.data &&
            e.response.data.data &&
            e.response.data.data.message,
        };
        store.commit("setError", error);
      }
    },

    async getCountryList({ commit }) {
      const res = await axios.get(`country-list`);

      const data = res && res.data && res.data.data;
      commit("setCountryList", data);
    },

    async getStateList({ commit }, payload) {
      const res = await axios.get(`state-list/${payload}`);

      const data = res && res.data && res.data.data;
      commit("setStateList", data);
    },

    async getCityList({ commit }, payload) {
      const res = await axios.get(`city-list/${payload}`);

      const data = res && res.data && res.data.data;
      commit("setCityList", data);
    },

    async getCardDetails({ commit }, payload) {
      const res = await axios.get(`user/get-card-data/${payload}`);

      const data = res && res.data && res.data.data;
      commit("setCardDetails", data);
    },

    async updateCardDetails({ commit }, payload) {
      try {
        const res = await axios.post(
          `user/update-card-data/${payload.id}`,
          payload.data
        );
        store.commit(
          "setIsSuccess",
          (res && res.data && res.data.message) || {}
        );
      } catch (e) {
        const error = {
          title: "Error occured",
          text:
            e.response &&
            e.response.data &&
            e.response.data.data &&
            e.response.data.data.message,
        };
        store.commit("setError", error);
      }
    },

    async postUserCompletePaymentBookClass({ commit }, payload) {
      const res = await axios.post(`user/complete-payment-book-class`, payload);
      store.commit("setIsSuccess", "Payment completed Successfully");

      const data = res && res.data && res.data.data;
      commit("setUserCompletePaymentBookClass", data);
    },

    async postUserCompleteTipPayment({ commit }, payload) {
      const res = await axios.post(`user/complete-tip-payment`, payload);
      store.commit("setIsSuccess", "Payment completed Successfully");

      const data = res && res.data && res.data.data;
      commit("setUserCompleteTipPayment", data);
    },

    async postUserBookFreeClass({ commit }, payload) {
      try {
        const res = await axios.post('user/book-free-class', payload)
        store.commit("setIsSuccess", "Session booked Successfully");
        const data = res && res.data && res.data.data;
        commit("setUserBookFreeClass", data);
      } catch (err) {
        commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err
      }
    },

    async getTrainerProfileDetails({ commit }, payload) {
      const res = await axios.get("trainer/profile-details");

      const data = res && res.data && res.data.data;
      commit("setTrainerProfileDetails", data);
    },
    async getAdminTrainerIntegrations({ commit }, payload) {
      try {
        const res = await axios.get(`admin/trainer/integration/${payload}`);
        const data = res && res.data && res.data.data;
        commit("setTrainerProfileDetails", data);
        store.commit("setSyncStatus", data.syncStatus);
      } catch(err) {
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },

    async getUserProfileDetails({ commit }, payload) {
      const res = await axios.get("user/profile-details");

      const data = res && res.data && res.data.data;
      commit("setUserProfileDetails", data);
    },

    async postTrainerTipTransactionList({ commit }, payload) {
      store.commit("setIsLoading", true);
      try {
        const res = await axios.post(`trainer/tip-transaction-list`, {}, {
          params: { ...payload.data }
        });
        const data = res && res.data && res.data.data;
        commit("setTrainerTipTransactionList", data);
        store.commit("setIsLoading", false);
      } catch(err) {
        store.commit("setIsLoading", false);
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },
    async postAdminTrainerTipTransactionList({ commit }, payload) {
      store.commit("setIsLoading", true);
      try {
        const res = await axios.get(`admin/trainer/tip-transaction-list/${payload.userId}`, {
          params: { ...payload.data }
        });
        const data = res && res.data && res.data.data;
        commit("setTrainerTipTransactionList", data);
        store.commit("setIsLoading", false);
      } catch(err) {
        store.commit("setIsLoading", false);
        // store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },
    async postUserOrderList({ commit }, { payload = {}, query }) {
      const res = await axios.post(`user/order-list`, payload, {
        params: { page: query.page },
      });
      const data = res && res.data && res.data.data;
      commit("setUserOrderList", data);
    },

    async postUserTipTransactionList({ commit }, { payload = {}, query }) {
      const res = await axios.post(`user/tip-transaction-list`, payload, {
        params: { page: query.page },
      });
      const data = res && res.data && res.data.data;
      commit("setUserTipTransactionList", data);
    },

    async postUserCancelOrder({ commit }, orderId) {
      try {
        const res = await axios.post(`user/cancel-order/${orderId}`);
        store.commit("setIsSuccess", res && res.data && res.data.message);
        const data = res && res.data && res.data.data;
        commit("setUserCancelOrder", data);
      } catch(err) {
        console.log(err);
        throw err;
      }
    },

    async postTrainerOrderList({ commit }, payload) {
      store.commit("setIsLoading", true);
      try {
        const res = await axios.post(`trainer/order-list`, {}, {
          params: { ...payload.data }
        });
        const data = res && res.data && res.data.data;
        commit("setTrainerOrderList", data);
        store.commit("setIsLoading", false);
      } catch(err) {
        store.commit("setIsLoading", false);
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },
    async postAdminTrainerOrderList({ commit }, payload) {
      store.commit("setIsLoading", true);
      try {
        const res = await axios.get(`admin/trainer/${payload.userId}/sales`, {
          params: { ...payload.data }
        });
        const data = res && res.data && res.data.data;
        commit("setTrainerOrderList", data);
        store.commit("setIsLoading", false);
      } catch(err) {
        store.commit("setIsLoading", false);
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },

    async getUserInvoice({ commit }, payload) {
      await axios
        .get(`user/order-invoice/${payload.id}`)
        .then((response) => {
          // const linkSource = `data:application/pdf;base64,[${response.data}]`;
          // const downloadLink = document.createElement("a");
          // const fileName = `${payload.label}.pdf`;
          // downloadLink.href = linkSource;
          // downloadLink.download = fileName;
          // downloadLink.click();
          const byteString = response && response.data && window.atob(response.data.data);
          const arrayBuffer = new ArrayBuffer(byteString.length);
          const int8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([int8Array], { type: 'application/pdf' });

          const url = URL.createObjectURL(blob);

          // to open the PDF in a new window
          window.open(url, '_blank');
        })
        .catch(console.error);
    },

    async getUserTipTransactionInvoice({ commit }, payload) {
      await axios
        .get(`user/tip-transaction-invoice/${payload.id}`)
        .then((response) => {
          const byteString = response && response.data && window.atob(response.data.data);
          const arrayBuffer = new ArrayBuffer(byteString.length);
          const int8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([int8Array], { type: 'application/pdf' });

          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        })
        .catch(console.error);
    },

    async getTrainerOrderInvoice({ commit }, payload) {
      await axios
        .get(`trainer/order-invoice/${payload.id}`)
        .then((response) => {
          const byteString = response && response.data && window.atob(response.data.data);
          const arrayBuffer = new ArrayBuffer(byteString.length);
          const int8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([int8Array], { type: 'application/pdf' });

          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        })
        .catch(console.error);
    },
    async getAdminTrainerOrderInvoice({commit}, payload) {
      await axios
        .get(`admin/trainer/download-session-invoice/${payload.trainerId}/${payload.id}`)
        .then((response) => {
          const byteString = response && response.data && window.atob(response.data.data);
          const arrayBuffer = new ArrayBuffer(byteString.length);
          const int8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([int8Array], { type: 'application/pdf' });

          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        })
        .catch(console.error);
    },
    async getTrainerTipTransactionInvoice({ commit }, payload) {
      await axios
        .get(`trainer/tip-transaction-invoice/${payload.id}`)
        .then((response) => {
          const byteString = response && response.data && window.atob(response.data.data);
          const arrayBuffer = new ArrayBuffer(byteString.length);
          const int8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([int8Array], { type: 'application/pdf' });

          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        })
        .catch(console.error);
    },
    async getAdminTrainerTipInvoice({commit}, payload) {
      await axios
        .get(`admin/trainer/download-tip-invoice/${payload.trainerId}/${payload.id}`)
        .then((response) => {
          const byteString = response && response.data && window.atob(response.data.data);
          const arrayBuffer = new ArrayBuffer(byteString.length);
          const int8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([int8Array], { type: 'application/pdf' });

          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        })
        .catch(console.error);
    },

    async postChangePassword({ commit }, data) {
      try {
        const res = await axios.post(`change-password`, data);
        store.commit("setIsSuccess", res && res.data && res.data.message);
      } catch(err) {
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },
  },

  mutations: {
    setUserProfileDetails(state, data) {
      state.userProfileDetails = data;
    },
    setTrainerProfileDetails(state, data) {
      state.trainerProfileDetails = data;
    },
    setTrainerTipTransactionList(state, data) {
      state.trainerTipTransactionList = data;
    },
    setUserOrderList(state, data) {
      state.userOrders = data;
    },
    setUserTipTransactionList(state, data) {
      state.userTipTransactionList = data;
    },
    setUserCancelOrder(state, data) {
      state.userCancelOrder = data
    },
    setTrainerOrderList(state, data) {
      state.trainerOrderList = data;
    },
    setUserCompletePaymentBookClass(state, data) {
      state.userCompletePaymentBookClass = data;
    },
    setUserCompleteTipPayment(state, data) {
      state.userCompleteTipPayment = data
    },
    setUserBookFreeClass(state, data) {
      state.userBookFreeClass = data
    },
    setLanguageTrainerList(state, data) {
      state.languageTrainerList = data;
    },
    setUserRoles(state, data) {
      state.roles = data;
    },
    setUserCardList(state, data) {
      state.userCardList = data;
    },
    setCountryList(state, data) {
      state.countries = data;
    },
    setStateList(state, data) {
      state.states = data;
    },
    setCityList(state, data) {
      state.cities = data;
    },
    setCardDetails(state, data) {
      state.cardDetails = data;
    },
    setCategoryTrainerList(state, data) {
      state.categoryTrainerList = data;
    },
    setTopTrainerList(state, data) {
      state.topTrainerList = data;
    },
    setCategoriesList(state, data) {
      state.categoriesList = data.category;
    },
    setTrainerProfileUpdateDp(state, data) {
      const details = JSON.parse(localStorage.getItem("details"));
      details.thumbnail_url = data && data.thumbnail_url;
      const newDetails = JSON.stringify(details);
      localStorage.setItem("details", newDetails);
      state.trainerProfile.profile.thumbnail_url = data && data.thumbnail_url;
    },

    setUserProfileUpdateDp(state, data) {
      const details = JSON.parse(localStorage.getItem("details"));
      details.thumbnail_url = data.thumbnail_url;
      details.banner_url = data.banner_url;
      const newDetails = JSON.stringify(details);
      localStorage.setItem("details", newDetails);
      state.userProfile.personal_details = data;
    },

    setUserProfileRemoveDp(state, data) {
      const details = JSON.parse(localStorage.getItem("details"));
      details.thumbnail_url = "";
      const newDetails = JSON.stringify(details);
      localStorage.setItem("details", newDetails);
      state.userProfileRemoveDp = data;
    },

    setTrainerProfileBannerRemove(state, data) {
      state.trainerProfileBannerRemove = data;
    },
    setTrainerProfileRemoveDp(state, data) {
      const details = JSON.parse(localStorage.getItem("details"));
      details.thumbnail_url = "";
      const newDetails = JSON.stringify(details);
      localStorage.setItem("details", newDetails);
      state.trainerProfileRemoveDp = data;
    },

    setUserMessageNew(state, data) {
      state.userMessageNew = data;
    },
    setUserSessionTxnHistory(state, data) {
      state.userSessionTxnHistory = data;
    },
    setUserCourseTxnHistory(state, data) {
      state.userCourseTxnHistory = data;
    },
    setUserCreditPurchaseHistory(state, data) {
      state.userCreditPurchaseHistory = data;
    },
    setTrainerActiveSessions(state, data) {
      state.trainerActiveSessions = data;
    },
    setPostCommentLike(state, data) {
      state.postCommentLike = data;
    },
    setCommentDelete(state, data) {
      state.commentDelete = data;
    },
    setUserTrainerPosts(state, data) {
      state.userTrainerPosts = data;
    },
    setUserFollowedTrainerPosts(state, data) {
      state.userFollowedTrainerPosts = data;
    },
    setPostComment(state, data) {
      state.trainerPostView.comments.unshift(data);
    },
    setTrainerPostDelete(state, data) {
      state.trainerPostDelete = data;
    },
    setTrainerPostView(state, data) {
      state.trainerPostView = data;
    },
    setTrainerPostList(state, data) {
      state.trainerPostList = data;
    },
    setTrainerPostCreate(state, data) {
      state.trainerPostList.data && state.trainerPostList.data.length ? '' : state.trainerPostList.data = []
      const userDetails = JSON.parse(localStorage.getItem("details"));
      userDetails && userDetails.thumbnail_url && userDetails.thumbnail_url.length ? data.thumbnail_url = userDetails.thumbnail_url : ''
      data.like_counter = 0
      data.total_comments = 0
      state.trainerPostList.data.unshift(data);
    },
    setUserReviewTrainerPost(state, data) {
      state.userReviewTrainerPost = data;
    },
    setUserFollowTrainer(state, data) {
      state.userFollowTrainer = data;
    },
    setTrainerDetail(state, data) {
      state.trainerDetail = data;
    },
    setTrainerReviews(state, data) {
      state.trainerReviews = data;
    },
    setTrainerProfile(state, data) {
      state.trainerProfile = data;
    },
    setUserProfile(state, data) {
      state.userProfile = data;
    },
    setUserProfileUpdate(state, data) {
      localStorage.setItem("details", JSON.stringify(data));
      const user = JSON.parse(localStorage.getItem("user"));
      user.name = data.f_name + " " + data.l_name;
      user.timezone = data && data.timezone;
      const newUser = JSON.stringify(user);
      localStorage.setItem("user", newUser);
      state.userProfileUpdate = data;
    },

    setTrainerProfileUpdate(state, data) {
      const details = JSON.parse(localStorage.getItem("details"));
      details.thumbnail_url = data.thumbnail_url;
      const newDetails = JSON.stringify(details);
      localStorage.setItem("details", newDetails);
      state.trainerProfileUpdate = data;
      const user = JSON.parse(localStorage.getItem("user"));
      user.timezone = data && data.timezone;
      const newUser = JSON.stringify(user);
      localStorage.setItem("user", newUser);
    },

    setTrainerProfileBannerUpdate(state, data) {
      // state.trainerProfileBannerUpdate = data;
      const details = JSON.parse(localStorage.getItem("details"));
      details.banner_url = data.banner_url;
      const newDetails = JSON.stringify(details);
      localStorage.setItem("details", newDetails);
      state.trainerProfile.profile.banner_url = data.banner_url;
    },

    setSessionReviewBatch(state, data) {
      state.sessionReviewBatch = data;
    },
    setUserReviewSessionPost(state, data) {
      state.userReviewSessionPost = data;
    },
    setUserReviewLike(state, data) {
      state.userReviewLike = data;
    },
    setTrainerProfileReviews(state, data) {
      state.trainerProfileReviews = data;
    },
    setLivestreamSessionBatch(state, data) {
      state.livestreamSessionBatch = data;
    },
    setTrainerList(state, data) {
      state.trainerList = data;
    },
    setTrainerStoreAdd(state, data) {
      state.trainerStoreList.data.unshift(data);
    },
    setTrainerStoreList(state, data) {
      state.trainerStoreList = data;
    },
    setTrainerStoreListMore(state, data) {
      state.trainerStoreList.next_page_url = data.next_page_url;
      data.data.map((d) => {
        state.trainerStoreList.data.push(d);
      });
    },

    setUserStoreList(state, data) {
      state.userStoreList = data;
    },
    setTrainerStoreView(state, data) {
      state.trainerStoreView = data;
    },
    setTrainerStoreUpdate(state, data) {
      state.trainerStoreUpdate = data;
    },
    setTrainerStoreDelete(state, data) {
      state.trainerStoreDelete = data;
    },
    setTrainerViewStores(state, data) {
      state.trainerViewStores = data;
    },
    setTrainerAddStores(state, data) {
      state.trainerAddStores = data;
    },
    setChatBotVisibility(state, flag) {
      state.isChatBotVisible = flag
    },
    setTutorialNotifier(state, flag) {
      state.tutorialNotified = flag
    }
  },
};